import { z } from 'zod';

export const getTaxesResponseSchema = z.object({
  amount: z.number(),
  currency: z.string(),
  tax_type: z.number(),
  tax_rate: z.number(),
  tax_sum: z.number(),
  fee: z.number(),
  fee2: z.number(),
  total: z.number()
});

export const getTaxesResponseDataSchema = z.object({
  error: z.string(),
  error_code: z.string(),
  response: getTaxesResponseSchema.nullable()
});

const noTaxableSchema = z.object({
  no_tax_fee: z.number(),
  no_tax_fee_rate: z.number(),
  no_tax_received: z.number(),
  no_tax_sum: z.number()
});

const taxableSchema = z.object({
  tax_fee: z.number(),
  tax_fee_rate: z.number(),
  tax_military: z.number(),
  tax_military_rate: z.number(),
  tax_personal: z.number(),
  tax_personal_rate: z.number(),
  tax_received: z.number(),
  tax_sum: z.number()
});

export const getNewTaxesSchema = z.object({
  no_taxable: noTaxableSchema,
  taxable: taxableSchema
});

export const getTaxesNewResponseSchema = z
  .object({
    no_taxable: noTaxableSchema,
    taxable: taxableSchema
  })
  .nullable();

export const getTaxesByCodeDataSchema = z
  .object({
    amount: z.number(),
    tax: z.number(),
    amount_taxed: z.number()
  })
  .nullable();

export const getTaxesNewResponseDataSchema = z.object({
  error: z.string(),
  error_code: z.string(),
  response: getTaxesNewResponseSchema
});

export const getTaxesByCodeResponseSchema = z.object({
  status: z.string(),
  data: getTaxesByCodeDataSchema
});
